import React from 'react'
import { Typography, Button, Card, useUser } from '@paintscout/ui'
import { useTrialOverDashboard } from '../useTrialOverDashboard'
import StatCard5minBackground from '../../shared/svgs/StatCard5minBackground'
import StatCard350kBackground from '../../shared/svgs/StatCard350kBackground'
import StatCard1JobBackground from '../../shared/svgs/StatCard1JobBackground'
import StatCard2BBackground from '../../shared/svgs/StatCard2BBackground'
import { useTrialOverDashboardMobileLayoutStyles } from './useTrialOverDashboardMobileLayoutStyles'

export default function TrialOverDashboardMobile() {
  const classes = useTrialOverDashboardMobileLayoutStyles()
  const { isAdmin, handleSelectPlan } = useTrialOverDashboard()
  const { isChurned } = useUser()

  const stats = [
    {
      value: '5min',
      label: ['Average time spent ', 'per estimate'],
      background: <StatCard5minBackground />
    },
    {
      value: '350k+',
      label: ['Estimates closed ', 'with PaintScout'],
      background: <StatCard350kBackground />
    },
    {
      value: '1 Job',
      label: ['To pay off your ', 'annual subscription'],
      background: <StatCard1JobBackground />
    },
    {
      value: '2B+',
      label: ['Dollars sold ', 'to date'],
      background: <StatCard2BBackground />
    }
  ]

  return (
    <div className={classes.root}>
      <div className={classes.leftSection}>
        <Typography className={classes.heading}>
          <span className={classes.headingFirstLine}>
            <span className={classes.headingHighlight}>Your PaintScout trial is over,</span>
          </span>
          <span className={classes.headingSecondLine}>but it doesn&lsquo;t have to end here.</span>
        </Typography>
        {isAdmin && !isChurned && (
          <Button
            variant="contained"
            color="primary"
            size="medium"
            onClick={handleSelectPlan}
            className={classes.button}
          >
            Select Plan
          </Button>
        )}
      </div>
      <div className={classes.whiteBackground}>
        <div className={classes.rightSection}>
          <div className={classes.statsGrid}>
            {stats.map((stat, index) => (
              <Card key={index} className={classes.statCard}>
                <div className={classes.statCardBackground}>{stat.background}</div>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
